import { useEffect } from 'react';

const RESUME_PDF_PATH = '/files/JenaroVegaBecerrilResumePublic2026.pdf';

/**
 * /resume redirects to the PDF URL so the browser opens it in the standard
 * in-browser viewer (view + download button at top), not a custom page or auto-download.
 */
const Resume = () => {
  useEffect(() => {
    const origin = window.location.origin;
    const pdfUrl = `${origin}${RESUME_PDF_PATH}`;
    window.location.replace(pdfUrl);
  }, []);

  return null;
};

export default Resume;
